export const PARAM_TYPES = {
    STRING: "string",
    INTEGER: "integer",
    STRING_LIST: "string[]",
    STRING_2D_LIST: "string[][]",
    DATE: "date",
    DATE_LIST: "date[]",
    DATE_RANGE: "daterange",
    DATE_RANGE_LIST: "daterange[]",
    BOOLEAN: "boolean",
    DICT_LIST: "dict[]",
}

export const PARAM_NAMESPACES = {
    DATES: "dates",
    METRICS: "metrics",
    PLAYERS: "players",
    POSITIONS: "positions",
    PLAYER_GROUPS: "player_groups",
    STATUSES: "statuses",
    FLAGS: "flags",
    TREATMENTS: "treatments"
}
